var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"at-chatbtn-wrap"},[_c('a',{staticClass:"at-chatbtn",class:{'at-disable-btn': _vm.isLoading },attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.preventDefault();return _vm.getPostInfo()}}},[_c('i',{staticClass:"guppy-message-square"}),_vm._v(_vm._s(_vm.TRANS.start_chat_txt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }